import {
  put, call, takeLatest,
} from 'redux-saga/effects';
// eslint-disable-next-line import/no-unresolved
import { ErrorManagement } from '@printdeal/error-management/react';
import { actions as customerActions } from '../slices/customerSlice';
import { ServiceFactory } from '../../services/ServiceFactory';
import { getHumanErrorFromResponse } from '../../helpers/error';

export function* getCustomer({ payload }) {
  yield put(customerActions.getCustomerRequest());

  try {
    const { decodedToken, account } = payload;
    const customerService = yield call([ServiceFactory, 'createCustomerService']);
    const customer = yield call([customerService, 'getCustomer']);

    yield put(customerActions.getCustomerSuccess({
      customer: {
        ...customer,
        ...(account || decodedToken.account),
      },
    }));
  } catch (error) {
    ErrorManagement.exception({
      exception: error,
      tags: {
        fileLocation: 'customerSaga',
        featureFunction: 'getCustomer',
      },
      fingerprint: ['customer-saga-get-customer'],
    });
    yield put(customerActions.getCustomerFailure({
      error: getHumanErrorFromResponse(error),
    }));
  }
}

export function* getAccount({ payload }) {
  yield put(customerActions.getAccountRequest());

  try {
    const { decodedToken } = payload;
    const customerService = yield call([ServiceFactory, 'createCustomerService']);
    const account = yield call([customerService, 'getAccount']);

    yield put(customerActions.getAccountSuccess({
      account: {
        // Add account id from token because it is not returned from service
        id: decodedToken.account.id,
        ...account,
      },
    }));
  } catch (error) {
    ErrorManagement.exception({
      exception: error,
      tags: {
        fileLocation: 'customerSaga',
        featureFunction: 'getAccount',
      },
      fingerprint: ['customer-saga-get-account'],
    });
    yield put(customerActions.getAccountFailure({
      error: getHumanErrorFromResponse(error),
    }));
  }
}

export function* updateSurveyDetails({ payload }) {
  yield put(customerActions.updateSurveyDetailsSuccess(payload));
}

export default [
  takeLatest(customerActions.getCustomer, getCustomer),
  takeLatest(customerActions.updateSurveyDetails, updateSurveyDetails),
];
